import { Users } from '@platform/client';
import { useLocation } from 'wouter';
import EVENTS from '../analytics/events';
import dataTestids from '../constants/test-ids';
import { ROUTES } from '../routes/consts';
import NavbarDropdown, { NavbarDropdownItem } from './NavbarDropdown';

/** Shows user-level nav links in the Dashboard */
const ProfileDropdown = () => {
  const userData = Users.useGetCurrentUser();

  const location = useLocation();
  const currentRoute = location[0];

  const logoutHref = import.meta.env.VITE_API_HOST + '/login/logout';

  const menuItems: NavbarDropdownItem[] = [
    {
      title: 'Home',
      href: ROUTES.DASHBOARD,
      linkType: 'internal',
      eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.HOME_CLICKED,
      // Currently our nested routing matches '/' here when on the dashboard home page. We only show
      // the profile dropdown on a few pages and the only ohter navigable option in this dropdown is
      // Account and Profile, which is a legacy page and doesn't use this dropdown. We'll need to rework
      // this dropdown along with updated navigation in the near future.
      active: currentRoute === '/',
    },
    {
      title: 'Account and Profile',
      href: `${ROUTES.DASHBOARD}${ROUTES.ACCOUNT}`,
      linkType: 'internal',
      eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.ACCOUNT_AND_PROFILE_CLICKED,
      // active handled by the legacy app
    },
    {
      title: 'Logout',
      href: logoutHref,
      linkType: 'external',
      newTab: false,
      eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.LOGOUT_CLICKED,
    },
  ];

  return (
    <NavbarDropdown
      avatar={userData.data?.avatar || ''}
      avatarFallbackIcon='user-01'
      buttonText={userData?.data ? `${userData.data.firstName} ${userData.data.lastName}` : ''}
      isLoading={!userData.isSuccess}
      items={menuItems}
      dataTestId={dataTestids.LAYOUT.PROFILE_DROPDOWN}
    />
  );
};

export default ProfileDropdown;
